<template>
	<b-modal v-model="show" centered hide-footer hide-header @hide="$emit('ok', $event)">
		<div class="row">
			<div class="col">
				<p>{{message | trans}}</p>
				<div v-if="!hideButton">
					<b-button class="btn-success" @click="hideButton=true; $emit('ok', $event)">
						{{'Ok' | trans}}</b-button>
				</div>
				<div v-else>
					{{'Please wait ...' | trans}}
				</div>
			</div>
		</div>
	</b-modal>
</template>

<script>
	export default {
		name: "success-component",
		props: ['pMessage', 'pShow'],
		data() {
			return {
				'message': 'Success',
				show: false,
				hideButton: false
			}
		},
		mounted() {
			this.show = this.pShow;
		},
		watch: {
			pMessage(value) {
				this.message = value;
			},
			pShow(value) {
				this.show = value;
			}
		}
	}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/success-component.vue